const Error = () => {
    return ( 
        <div className="error-page">
            <p>Error! can't find the url you ar lookin for</p>
        </div>
     );
}
 
export default Error;